import React from "react";
import HeadingComp from "../HeadingComp";
// import { Controller } from 'react-hook-form';
import { Controller, useForm } from "react-hook-form";
import InputComp from "../../../../Components/common/textInput";
import Button from "../../../../Components/common/Button";
import { useState } from "react";
import EditSaveBtn from "../EditSaveBtn";
import APIHit from "../../../../utils/apiHit";
import { apiMainUser, checkErrors } from "../../../../utils/constant";
import { useDispatch } from "react-redux";
import { openSnackbar } from "../../../../utils/redux/SnackBarSlicer";

const EditAdvanceWindow = (props) => {
  
  const { control, handleSubmit, register,formState: { errors }, } = useForm();
  const [showerror, setError] = useState(null);

  const [postData, setPostData] = useState(null);

  const dispatch = useDispatch()


  let url = apiMainUser + "updatePropertyPref/" + props.propId;

      const onSubmit = (data) => {
        console.log(data,'uu')
        const postDatavalue = {
          advance_window: data.advance_Window,
    
        };
        setPostData(postDatavalue);
       
      };


  

      const handleSuccess = (res) => {
        if (res.status === "success") {
          props.closeModal()
          props.fetchData()
          dispatch(openSnackbar({ message: 'updated Successfully', severity: 'success' }));

        }
      };
    
      const handleFailure = (res) => {
        console.log(res);
        if (res && res.status === 404) {
          setError("");
          dispatch(openSnackbar({ message: 'Something went Wrong', severity: 'success' }));

        } else {
          setError("");
          dispatch(openSnackbar({ message: 'Something went Wrong', severity: 'success' }));

        }
      };
    
      const preCondition = () => {
        let ercheck = checkErrors(errors);
        console.log(ercheck, "djjd");
        return ercheck;
      };


      
return (
  <>


<div className="edit-booking-preference " style={{marginTop:'2rem'}}>
<form className="edit-booking-pre-form" onSubmit={handleSubmit(onSubmit)} >
<div className="avail-window-box ">
   
      
      <Controller
          control={control}
          defaultValue={
              props.allData !== undefined ? props.allData?.advance_window : ""
             }
          name="advance_Window"
          rules={{
            required: "filled the data is required",
            min: {
              value: 0,
              message: "Maximum stay cannot be less than 0",
            },
          }}
       
          render={({ field: { onChange, value } }) => (
            <div>
            <InputComp
             inputType="number"
               inputClass="input"
               name="advance_Window"
               defaultValue={
                props.allData !== undefined ? props.allData?.advance_window : ""
               }
              onKeyUp={(event) => {
                onChange(event.target.value);
                // console.log(event.target.value, "topi");
                // onSubmit(event.target.value, true);
              }}
              value={value}
            />
                 {errors.advance_Window && (
            <span>{errors.advance_Window.message}</span>
          )}
          <p>Enter your advance window in days</p>
            </div>
          )}
          
        />
      </div>

           <APIHit
              handleSubmit={handleSubmit(onSubmit)}
              url={url}
              apidata={postData}
              method={"patch" }
              successResponseCode={200}
              onSuccess={handleSuccess}
              onFailure={handleFailure}
              precondition={preCondition} 
              auth={true}
            >
             

          <div className="clear_apply-btn-box paddingCustomYSide">
          <p onClick={() => props.closeModal(false)} className="clear-btn">
            Cancel
          </p>
          <button className="save-edit-btn">Save</button>
        </div>
            </APIHit>
    </form>
    </div>
  </>
)
};

export default EditAdvanceWindow;
